import type { MeetingAgendaNode, MeetingCreateInput, MeetingProvider } from '../../../types/meetings'

export const MEMBER_MEETING_MIN_DURATION_MINUTES = 15
export const MEMBER_MEETING_MAX_DURATION_MINUTES = 7 * 24 * 60

export const clampMemberMeetingDuration = (value: number) => Math.min(
  MEMBER_MEETING_MAX_DURATION_MINUTES,
  Math.max(MEMBER_MEETING_MIN_DURATION_MINUTES, Number.isFinite(value) ? Math.round(value) : MEMBER_MEETING_MIN_DURATION_MINUTES),
)

export const memberMeetingScheduledAt = (date: string, time: string) => {
  const scheduledAt = new Date(`${date}T${time || '09:00'}`)
  return Number.isNaN(scheduledAt.getTime()) ? null : scheduledAt.toISOString()
}

export const buildMemberMeetingCreateInput = ({
  workspaceId,
  title,
  sourceProvider,
  date,
  time,
  durationMinutes,
  timezone,
  agendaMarkdown,
  agendaNodes = [],
  participantIds,
  scopeNodeId,
}: {
  workspaceId: string
  title: string
  sourceProvider: MeetingProvider
  date: string
  time: string
  durationMinutes: number
  timezone: string
  agendaMarkdown: string
  agendaNodes?: MeetingAgendaNode[]
  participantIds: string[]
  scopeNodeId?: string | null
}): MeetingCreateInput | null => {
  const scheduledAt = memberMeetingScheduledAt(date, time)
  if (!title.trim() || !scheduledAt) return null
  return {
    workspaceId,
    title: title.trim(),
    sourceProvider,
    scheduledAt,
    durationMinutes: clampMemberMeetingDuration(durationMinutes),
    timezone,
    agendaMarkdown,
    agendaNodes,
    participantIds,
    externalInvitees: [],
    ...(scopeNodeId !== undefined ? { scopeNodeId } : {}),
  }
}

export const dispatchMeetingPaywall = (workspaceId: string, error: unknown) => {
  const details = typeof error === 'object' && error !== null && 'details' in error
    ? (error as { details?: Record<string, unknown> }).details
    : undefined
  const code = typeof error === 'object' && error !== null && 'code' in error
    ? (error as { code?: unknown }).code
    : undefined
  const message = error instanceof Error ? error.message : ''
  if (code !== 'PAYWALL_REQUIRED' && details?.code !== 'PAYWALL_REQUIRED' && !message.includes('PAYWALL_REQUIRED')) return false
  window.dispatchEvent(new CustomEvent('linkhub:paywall-required', {
    detail: {
      workspaceId,
      featureKey: 'meetingsPerMonth',
      currentUsage: details?.currentUsage,
      limit: details?.limit,
      plan: details?.plan,
    },
  }))
  return true
}
